import React from 'react';
import {Card, Flex} from "antd";
import style from "./ProvinceCard.module.scss";
import {StyledCard} from "./ProvinceCard.styled";
import { FaChevronLeft } from "react-icons/fa6";
import {useNavigate} from "react-router-dom";
import {ProvinceCardProps} from "../../../models";

const ProvinceCard = ({title,id,onCategoryClick} :ProvinceCardProps) => {
    const navigate =useNavigate()
    return (
        <StyledCard  onClick={() => onCategoryClick(id)}  >
            <Flex justify={"space-between"} align={"center"}>
                <span> {title} </span>
                <span> <FaChevronLeft   className={style.icons}/> </span>

            </Flex>
        </StyledCard>
    )

};

export default ProvinceCard;
